import LegislativnyProcesDetail from './PrispevokVestnikaDetailPage';

export default LegislativnyProcesDetail;
